import { useState, useEffect, useCallback } from 'react'
import { useSettings } from './useSettings'

export function useWelcome() {
  const { settings, loading: settingsLoading, updateSettings } = useSettings()
  const [showWelcome, setShowWelcome] = useState(false)
  const [welcomeLoading, setWelcomeLoading] = useState(true)

  useEffect(() => {
    if (settingsLoading) return

    const welcomeDismissed = settings?.dashboard?.welcome_dismissed === true
    if (!welcomeDismissed) {
      setShowWelcome(true)
    }
    setWelcomeLoading(false)
  }, [settingsLoading, settings?.dashboard?.welcome_dismissed])

  const dismissWelcome = useCallback(async () => {
    setShowWelcome(false)
    try {
      await updateSettings({
        dashboard: { ...settings?.dashboard, welcome_dismissed: true },
      })
    } catch {
      // Non-critical: modal is already dismissed locally
    }
  }, [settings?.dashboard, updateSettings])

  return {
    showWelcome,
    dismissWelcome,
    welcomeLoading,
  }
}
